import React from 'react';
import ReactDOM from 'react-dom';
import WhatsOn from './components/WhatsOn';

import * as Sentry from '@sentry/browser';
import './utils/webp'

// Error logging
if (window.location.hostname !== 'localhost' && window.location.hostname !== 'globe.test' && window.WP_CONFIG && window.WP_CONFIG.SENTRY_DSN) {
    Sentry.init({
        dsn: window.WP_CONFIG.SENTRY_DSN
    });
}
const appContainer = document.getElementById('app-whats-on');
if (appContainer) {
    ReactDOM.render(<WhatsOn />, appContainer);
}



// WEBPACK FOOTER //
// ./src/whatson/index.js